/*
* parallaxBackgrounds - jQuery plugin
* Copyright (c) 2017 Adam Lafene
*
* Licensed under the terms of the MIT and GPL licenses:
*   http://www.opensource.org/licenses/mit-license.php
*   http://www.gnu.org/licenses/gpl.html
*/


(function(d){d.fn.parallaxBackgrounds=function(l){var e=this,f=l||"",g=[],c,h,m=function(){c=0<f.length?f.outerHeight():0;h=window.innerHeight-c;e.each(function(c){var a=d(this);g[c]={height:parseInt(a.outerHeight()),top:parseInt(a.offset().top)}})},k=function(){var f=window.pageYOffset||document.documentElement.scrollTop;e.each(function(a){if(g[a]){var b=g[a].height;a=g[a].top;b=Math.round((a-f-c+b)/((a-c>h?h+b:a-c+b)/100));b=100<b?100:0>b?0:b;d(this).css("background-position","50% "+b+"%")}})};
this.update=function(){m();k()};if(1>e.length)return 0;d(document).ready(function(){e.update()});d(window).scroll(function(){k()});return this}})(jQuery);